import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';
import logo from '../assets/images/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Handle scroll effect for a premium feel
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Why Us', path: '/why-optirev' },
    { name: 'About', path: '/about' },
  ];

  return (
    <header className={`sticky top-0 z-[100] transition-all duration-300 ${
      isScrolled ? 'bg-white/90 backdrop-blur-md shadow-md py-2' : 'bg-white py-4'
    }`}>
      <nav className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        
        {/* Logo - Focus on Brand Identity */}
        <Link to="/" className="flex items-center group">
          <img 
            src={logo} 
            alt="OptiRev Healthcare" 
            className="h-12 md:h-16 w-auto transition-transform group-hover:scale-105" 
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`text-sm font-bold tracking-wide uppercase transition-colors ${
                location.pathname === link.path ? 'text-[#14b8a6]' : 'text-[#1e3a8a] hover:text-[#14b8a6]'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link 
            to="/contact" 
            className="bg-[#1e3a8a] text-white px-7 py-3 rounded-full font-bold text-sm hover:bg-[#14b8a6] transition-all shadow-lg hover:shadow-[#14b8a6]/20 flex items-center gap-2"
          >
            Book a Demo <ChevronRight size={16} />
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-[#1e3a8a]" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {/* Mobile Sidebar Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t absolute w-full left-0 p-6 shadow-2xl animate-in slide-in-from-top">
          <div className="flex flex-col gap-6">
            {navLinks.map((link) => (
              <Link 
                key={link.name} 
                to={link.path} 
                className="text-lg font-bold text-[#1e3a8a]"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Link 
              to="/contact" 
              className="bg-[#14b8a6] text-white text-center py-4 rounded-xl font-bold"
              onClick={() => setIsMenuOpen(false)}
            >
              Request Assessment
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;